import Cookies from 'js-cookie';

enum urls {
    prod = 'https://carmaxauctions.com/opt-out',
    qa = 'https://wwwqa.carmaxauctions.com/opt-out',
}

export function setOptOutCookie(onSuccess?: () => void) {
    fetch('/privacy-policy/opt-out', { method: 'POST' }).then((res) => {
        if (res.status === 202) {
            onSuccess?.();
        }
    });
    setAuctionCookie();
}

function setAuctionCookie() {
    const url = window.location.hostname;
    const redirectUrl = url.indexOf('wwwqa.') > -1 ? urls.qa : urls.prod;
    window.open(redirectUrl, 'windowName', 'height=0,width=0');
}
